import { logEvent } from '@eventbrite/legacy-infra.statsig';
import { heapTrackClick } from '../../utils/heap-data';

export const trackClickWithElementID = (metricName: string, elementDataIdentifier: string) => {
    const normalizedIdentifier = elementDataIdentifier.replaceAll(/[\s-]+/g, '-').toLowerCase();
    const dimensions = { elementIdentifier: normalizedIdentifier };

    trackClickWithDimensions(metricName, dimensions);
};

export const trackClickWithDimensions = (
    metricName: string,
    dimensions: Record<string, string>,
) => {
    try {
        logEvent(metricName, 1, dimensions);
        heapTrackClick(metricName, dimensions);
    } catch {
        // noop
    }
};
